// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { api } from "./api";

/**
 * Kick off the Google OAuth flow.
 * - Saves the current path to sessionStorage so AuthGoogle.jsx can return here after login
 * - Builds redirect_uri from window.location.origin + "/auth/google"
 * - Backend returns a CSRF-protected Google consent URL
 * - We then redirect the browser to Google
 *
 * Used by Navbar, Profile, Watchlist mobile drawer, Games, Discussions, Live Chat.
 */
export async function startGoogleLogin() {
  // Save where the user is right now so we can return them after login
  const returnPath = window.location.pathname + window.location.search + window.location.hash;
  if (returnPath && returnPath !== "/auth/google") {
    // Use localStorage (not sessionStorage) so iOS Safari ITP doesn't clear
    // it during the cross-site OAuth redirect chain.
    localStorage.setItem("fm_login_return", returnPath);
  }

  const redirectUri = window.location.origin + "/auth/google";
  try {
    const r = await api.post("/auth/google/url", { redirect_uri: redirectUri });
    if (r.data?.auth_url) {
      window.location.href = r.data.auth_url;
    } else {
      throw new Error("No auth_url in response");
    }
  } catch (e) {
    // Log the actual error so it's visible in the browser console
    console.error("[filmistani] startGoogleLogin failed:", e?.response?.status, e?.message, e);
    alert("Sign-in is temporarily unavailable. Please try again in a moment.");
    throw e;
  }
}
